import { createStyles, Stack, StackProps, Text } from '@mantine/core';
import React from 'react';

interface CustomerAnalyticsWidgetWrapperProps extends StackProps {
  widgetTitle?: string;
}

export function AnalyticsWidgetWrapper({
  widgetTitle,
  children,
  ...stackProps
}: CustomerAnalyticsWidgetWrapperProps) {
  const { classes } = useStyles();

  return (
    <Stack className={classes.sectionContainer} {...stackProps}>
      <Text size="md" color="gray.6">
        {widgetTitle}
      </Text>
      {children}
    </Stack>
  );
}

const useStyles = createStyles((theme) => ({
  sectionContainer: {
    width: '100%',
    padding: theme.spacing.xxl,
    backgroundColor: theme.white,
    borderRadius: theme.radius.lg,
  },
}));
